export default __webpack_public_path__ + "static/b2-7489d2741b6d833efd2472b5b42265ce.png";